<h2 mat-dialog-title>{{ event ? "Edit event " + event.shortName : 'New event' }}</h2>

@if (loading()) {
<div class="n-spinner-overlay">
    <mat-spinner></mat-spinner>
</div>
} @else {
<div>
    <form [formGroup]="eventForm" class="event-form-content">
        <mat-tab-group>
            <mat-tab label="Event">
                <div class="row">
                    <mat-form-field appearance="outline" class="small-field">
                        <mat-label>Event short name</mat-label>
                        <input matInput type="text" formControlName="shortName">
                        @if(eventForm.get('shortName')?.hasError('required') ) {
                        <mat-error> Short name is required. </mat-error>
                        }
                        @if(eventForm.get('shortName')?.hasError('maxlength') ) {
                        <mat-error> Max length is 10 characters. </mat-error>
                        }
                        @if(eventForm.get('shortName')?.hasError('pattern') ) {
                        <mat-error> Short name can contains only letters and numbers. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="large-field">
                        <mat-label>Event name</mat-label>
                        <input matInput type="text" formControlName="name">
                        @if(eventForm.get('name')?.hasError('required')) {
                        <mat-error> Name is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Event date</mat-label>
                        <input matInput [matDatepicker]="datePicker" formControlName="date">
                        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                        <mat-datepicker #datePicker></mat-datepicker>
                        @if (eventForm.get('date')?.hasError('required') ) {
                        <mat-error>Event date is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>End date</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="small-field">
                        <mat-label>Invoice prefix</mat-label>
                        <input matInput type="text" formControlName="invoicePrefix">
                        @if(eventForm.get('invoicePrefix')?.hasError('required') )
                        {
                        <mat-error> Invoice prefix is required. </mat-error>
                        }
                        @if(eventForm.get('invoicePrefix')?.hasError('maxlength') &&
                        eventForm.get('invoicePrefix')?.touched) {
                        <mat-error> Max length is 10 characters. </mat-error>
                        }
                        @if(eventForm.get('invoicePrefix')?.hasError('pattern') )
                        {
                        <mat-error> Invoice prefix can contains only letters and numbers. </mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline" class="small-field">
                        <mat-label>Short location name</mat-label>
                        <input matInput type="text" formControlName="shortLocation">
                        <mat-hint>e.g. Brussels</mat-hint>
                        @if(eventForm.get('shortLocation')?.hasError('required') ) {
                        <mat-error> Short location is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="large-field">
                        <mat-label>Long location</mat-label>
                        <input matInput type="text" formControlName="location">
                        <mat-hint>e.g. Sheraton Brussels Airport Hotel</mat-hint>
                        @if(eventForm.get('location')?.hasError('required') ) {
                        <mat-error> Long location is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="large-field">
                        <mat-label>Event url</mat-label>
                        <input matInput type="text" formControlName="url">
                        @if(eventForm.get('url')?.hasError('required')) {
                        <mat-error> URL is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="small-field">
                        <mat-label>Logo file name</mat-label>
                        <input matInput type="text" formControlName="logoFileName">
                        @if(eventForm.get('logoFileName')?.hasError('required') ) {
                        <mat-error> Logo file name is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="large-field">
                        <mat-label>Welcome page title</mat-label>
                        <input matInput type="text" formControlName="pageTitle">
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Registration open date</mat-label>
                        <input matInput [matDatepicker]="registrationOpenDatePicker"
                            formControlName="registrationOpenDate">
                        <mat-datepicker-toggle matSuffix [for]="registrationOpenDatePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #registrationOpenDatePicker></mat-datepicker>
                        @if (eventForm.get('registrationOpenDate')?.hasError('required')) {
                        <mat-error>Registration open date is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Registration close date</mat-label>
                        <input matInput [matDatepicker]="registrationCloseDatePicker"
                            formControlName="registrationCloseDate">
                        <mat-datepicker-toggle matSuffix [for]="registrationCloseDatePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #registrationCloseDatePicker></mat-datepicker>
                        @if (eventForm.get('registrationCloseDate')?.hasError('required'))
                        {
                        <mat-error>Registration close date is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-checkbox formControlName="freeEvent" class="cb-field">Free event?</mat-checkbox>
                    <mat-checkbox formControlName="allowMultipleRegistrations" class="cb-field">Allow multiple
                        registrations?</mat-checkbox>
                    <mat-checkbox formControlName="usesPromoCodes" class="cb-field">Use promocodes?</mat-checkbox>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Early bird deadline</mat-label>
                        <input matInput [matDatepicker]="earlyBirdDeadlinePicker" formControlName="earlyBirdDeadline">
                        <mat-datepicker-toggle matSuffix [for]="earlyBirdDeadlinePicker"></mat-datepicker-toggle>
                        <mat-datepicker #earlyBirdDeadlinePicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="num-field">
                        <mat-label>One free registration for x paid ones</mat-label>
                        <input matInput type="number" formControlName="oneFreeFor">
                        @if (eventForm.get('oneFreeFor')?.hasError('required'))
                        {
                        <mat-error>One free for is required. </mat-error>
                        }
                        @if (eventForm.get('oneFreeFor')?.hasError('min') || eventForm.get('oneFreeFor')?.hasError('max'))
                        {
                        <mat-error>Number must be between 0 and 10. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="vat-field">
                        <mat-label>Applicable VAT rate</mat-label>
                        <input matInput type="number" step="0.01" formControlName="vatRate">
                        @if (eventForm.get('vatRate')?.hasError('required'))
                        {
                        <mat-error>VAT rate is required. </mat-error>
                        }
                        @if (eventForm.get('oneFreeFor')?.hasError('min') || eventForm.get('oneFreeFor')?.hasError('max'))
                        {
                        <mat-error>Number must be between 0 and 100%. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="large-field">
                        <mat-label>Contact email</mat-label>
                        <input matInput type="text" formControlName="contactEmail">
                        @if(eventForm.get('contactEmail')?.hasError('required')) {
                        <mat-error> Contact email is required. </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="large-field">
                        <mat-label>Hotel booking url</mat-label>
                        <input matInput type="text" formControlName="hotelBookingUrl">
                    </mat-form-field>
                </div>
            </mat-tab>

            <mat-tab label="Fees">
                <div class="row fees-section" formArrayName="fees">
                    <div class="full-width">
                        <div class="fees-header">
                            <h3>Fees</h3>
                            <button mat-mini-fab type="button" (click)="addFee()" [disabled]="isFreeEvent">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                        @for (feeGroup of eventForm.controls.fees.controls; track feeGroup; let i = $index) {
                        <div class="fee-card" [formGroupName]="i">
                            <div class="fee-row">
                                <mat-form-field appearance="outline" class="large-field fee-name-field">
                                    <mat-label>Name</mat-label>
                                    <input matInput type="text" formControlName="name">
                                    @if (feeGroup.get('name')?.hasError('required')) {
                                    <mat-error> Name is required. </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="small-field fee-target-field">
                                    <mat-label>Target</mat-label>
                                    <input matInput type="text" formControlName="target">
                                    <mat-hint>e.g. CLEPA member</mat-hint>
                                    @if (feeGroup.get('target')?.hasError('required')) {
                                    <mat-error> Target is required. </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="large-field fee-description-field">
                                    <mat-label>Description</mat-label>
                                    <input matInput type="text" formControlName="description">
                                    @if (feeGroup.get('description')?.hasError('maxlength')) {
                                    <mat-error> Max length is 512 characters. </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="small-field fee-price-field">
                                    <mat-label>Early bird price</mat-label>
                                    <input matInput type="number" step="0.01" formControlName="earlyBirdPrice">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="small-field fee-price-field">
                                    <mat-label>General price</mat-label>
                                    <input matInput type="number" step="0.01" formControlName="generalPrice">
                                    @if (feeGroup.get('generalPrice')?.hasError('required')) {
                                    <mat-error> General price is required. </mat-error>
                                    }
                                    @if (feeGroup.get('generalPrice')?.hasError('min')) {
                                    <mat-error> General price must be positive. </mat-error>
                                    }
                                </mat-form-field>
                                <button mat-icon-button type="button" class="fee-remove" (click)="removeFee(i)"
                                    [disabled]="isFreeEvent">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                        }
                        @if (eventForm.controls.fees.controls.length === 0) {
                        <p class="fees-empty">No fee defined yet.</p>
                        }
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Event texts">
                <div class="row texts-section">
                    <div class="full-width">
                        <div class="fees-header">
                            <h3>Header text</h3>
                        </div>
                        <mat-checkbox formControlName="noHeaderText" class="cb-field">No header text</mat-checkbox>
                        <div formGroupName="headerText">
                            <div class="fee-row">
                                <mat-form-field appearance="outline" class="large-field fee-name-field">
                                    <mat-label>Title</mat-label>
                                    <input matInput type="text" formControlName="title">
                                    @if (eventForm.controls.headerText.get('title')?.hasError('maxlength')) {
                                    <mat-error> Max length is 255 characters. </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <app-html-editor formControlName="body"></app-html-editor>
                        </div>
                    </div>
                    <div class="full-width">
                        <div class="fees-header">
                            <h3>Payment conditions</h3>
                        </div>
                        <mat-checkbox formControlName="noPaymentConditions" class="cb-field">No payment
                            conditions</mat-checkbox>
                        <div formGroupName="paymentConditions">
                            <div class="fee-row">
                                <mat-form-field appearance="outline" class="large-field fee-name-field">
                                    <mat-label>Title</mat-label>
                                    <input matInput type="text" formControlName="title">
                                    @if (eventForm.controls.paymentConditions.get('title')?.hasError('maxlength')) {
                                    <mat-error> Max length is 255 characters. </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <app-html-editor formControlName="body"></app-html-editor>
                        </div>
                    </div>
                    <div class="full-width">
                        <div class="fees-header">
                            <h3>Disclaimers</h3>
                            <button mat-mini-fab type="button" (click)="addDisclaimer()" title="Add a disclaimer">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                        <div cdkDropList class="options-groups-list" formArrayName="disclaimers"
                            (cdkDropListDropped)="dropDisclaimer($event)">
                            @for (disclaimer of eventForm.controls.disclaimers.controls; track disclaimer; let di = $index) {
                            <div class="option-group-card" cdkDrag [formGroupName]="di">
                                <div class="option-group-header">
                                    <mat-icon class="option-drag-handle" cdkDragHandle title="Drag to reorder">
                                        drag_indicator</mat-icon>
                                    <div class="full-width">
                                        <div class="fee-row">
                                            <mat-form-field appearance="outline" class="large-field fee-name-field">
                                                <mat-label>Title</mat-label>
                                                <input matInput type="text" formControlName="title">
                                                @if (disclaimer.get('title')?.hasError('maxlength')) {
                                                <mat-error> Max length is 255 characters. </mat-error>
                                                }
                                            </mat-form-field>
                                            <button mat-icon-button type="button" class="fee-remove"
                                                (click)="removeDisclaimer(di)" title="Remove this disclaimer">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                        <app-html-editor formControlName="body"></app-html-editor>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        @if (eventForm.controls.disclaimers.controls.length === 0) {
                        <p class="fees-empty">No disclaimer defined yet.</p>
                        }
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Registration options">
                <div class="row options-section" formArrayName="optionGroups">
                    <div class="full-width">
                        <div class="fees-header">
                            <h3>Registration options</h3>
                            <button mat-mini-fab type="button" (click)="addOptionGroup()"
                                title="Add an option group">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                        <div cdkDropList class="options-groups-list" (cdkDropListDropped)="dropOptionGroup($event)">
                            @for (group of eventForm.controls.optionGroups.controls; track group;
                            let gi = $index) {
                            <div class="option-group-card" cdkDrag [formGroupName]="gi">
                                <div class="option-group-header">
                                    <mat-icon class="option-drag-handle" cdkDragHandle title="Drag to reorder">
                                        drag_indicator</mat-icon>
                                    <div class="full-width">
                                        <div class="fee-row">
                                            <mat-form-field appearance="outline" class="large-field fee-name-field">
                                                <mat-label>Group label</mat-label>
                                                <input matInput type="text" formControlName="label"
                                                    placeholder="e.g. Do you plan to attend the gala dinner?">
                                                @if (group.get('label')?.hasError('required')) {
                                                <mat-error> Label is required. </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field appearance="outline" class="small-field">
                                                <mat-label>Short label</mat-label>
                                                <input matInput type="text" formControlName="shortLabel">
                                                @if (group.get('shortLabel')?.hasError('required')) {
                                                <mat-error> Short label is required. </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-checkbox formControlName="exclusive" class="cb-field">Exclusive
                                                (radio buttons)</mat-checkbox>
                                            @if (!group.controls.exclusive.value) {
                                            <mat-form-field appearance="outline" class="min-max-field">
                                                <mat-label>Min</mat-label>
                                                <input matInput type="number" formControlName="minAnswers">
                                            </mat-form-field>
                                            <mat-form-field appearance="outline" class="min-max-field">
                                                <mat-label>Max</mat-label>
                                                <input matInput type="number" formControlName="maxAnswers">
                                                <mat-hint>0 = no limit</mat-hint>
                                            </mat-form-field>
                                            }
                                            <mat-form-field appearance="outline" class="large-field">
                                                <mat-label>Hint</mat-label>
                                                <input matInput type="text" formControlName="hint">
                                            </mat-form-field>
                                            <button mat-icon-button type="button" class="fee-remove"
                                                (click)="removeOptionGroup(gi)" title="Remove this option group">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>

                                        <div class="fees-header">
                                            <h4>Answers</h4>
                                            <button mat-mini-fab type="button" (click)="addOptionItem(gi)"
                                                title="Add an answer">
                                                <mat-icon>add</mat-icon>
                                            </button>
                                        </div>
                                        <div cdkDropList class="options-items-list" [cdkDropListData]="gi"
                                            (cdkDropListDropped)="dropOptionItem(gi, $event)"
                                            formArrayName="optionItems">
                                            @for (item of group.controls.optionItems.controls; track item;
                                            let ii = $index) {
                                            <div class="option-item-row" cdkDrag [formGroupName]="ii">
                                                <mat-icon class="option-drag-handle" cdkDragHandle
                                                    title="Drag to reorder">drag_indicator</mat-icon>
                                                <mat-form-field appearance="outline" class="large-field fee-name-field">
                                                    <mat-label>Answer label</mat-label>
                                                    <input matInput type="text" formControlName="label">
                                                    @if (item.get('label')?.hasError('required')) {
                                                    <mat-error> Label is required. </mat-error>
                                                    }
                                                </mat-form-field>
                                                <mat-form-field appearance="outline" class="small-field">
                                                    <mat-label>Short label</mat-label>
                                                    <input matInput type="text" formControlName="shortLabel">
                                                    @if (item.get('shortLabel')?.hasError('required')) {
                                                    <mat-error> Short label is required. </mat-error>
                                                    }
                                                </mat-form-field>
                                                <button mat-icon-button type="button" class="fee-remove"
                                                    (click)="removeOptionItem(gi, ii)" title="Remove this answer">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                            }
                                            @if (group.controls.optionItems.controls.length === 0) {
                                            <p class="fees-empty">No answer defined yet.</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        @if (eventForm.controls.optionGroups.controls.length === 0) {
                        <p class="fees-empty">No registration option defined yet.</p>
                        }
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

        <div class="row buttons-row">
            <button matFab extended class="cancel-button" (click)="cancel()">
                <mat-icon>cancel</mat-icon>Cancel</button>
            <button matFab extended (click)="save()" [disabled]="loading()"> <mat-icon>save</mat-icon>Save</button>

        </div>
    </form>
</div>
}
